import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import Packages from "@/components/Packages";
import Manifesto from "@/components/Manifesto";
import RoadParallax from "@/components/RoadParallax";
import Instructors from "@/components/Instructors";
import Testimonials from "@/components/Testimonials";
import GoogleReview from "@/components/GoogleReview";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="bg-[#0a0a0a] text-[#f5f5f0] font-sans overflow-x-clip" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <MarqueeStrip />
        <Packages />
        <Manifesto />
        <RoadParallax />
        <Instructors />
        <Testimonials />
        <GoogleReview />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}
